import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Auth } from '../services/auth';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(Auth);
  const at = auth.getUserToken();
  if (!at) {
    return next(req);
  }
  const authReq = req.clone({
    setHeaders: {
      "At": at
    }
  });
  return next(authReq);
};
